import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { CheckCircle2, MailOpen } from "lucide-react";
import { API_URL, apiError } from "../lib/api";
import { Button } from "../components/ui/button";

export default function ConfirmPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    axios
      .get(`${API_URL}/public/confirm/${token}`)
      .then(({ data }) => {
        setInfo(data);
        setDone(data.already);
      })
      .catch(() => setInfo({ error: true }));
  }, [token]);

  const confirm = async () => {
    setBusy(true);
    try {
      await axios.post(`${API_URL}/public/confirm/${token}`);
      setDone(true);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6" data-testid="confirm-page">
      <div className="w-full max-w-sm bg-white border border-[#E5E5E5] rounded-2xl p-8 text-center">
        {!info ? (
          <p className="text-neutral-400">Loading…</p>
        ) : info.error ? (
          <p className="text-neutral-500" data-testid="confirm-invalid">This confirmation link is not valid.</p>
        ) : done ? (
          <div data-testid="confirm-done">
            <CheckCircle2 className="h-12 w-12 text-emerald-600 mx-auto" />
            <h1 className="mt-4 text-2xl font-black">Receipt confirmed</h1>
            <p className="mt-2 text-sm text-neutral-500">
              {info.business_name} has been notified that you read "<b>{info.subject}</b>".
            </p>
          </div>
        ) : (
          <>
            <MailOpen className="h-12 w-12 text-neutral-900 mx-auto" />
            <h1 className="mt-4 text-2xl font-black">Confirm you've read this email</h1>
            <p className="mt-3 text-sm text-neutral-500">
              <b>{info.business_name}</b> sent you "<b>{info.subject}</b>". Please confirm you have received and read it.
            </p>
            <Button onClick={confirm} disabled={busy} className="mt-6 w-full rounded-full h-12" data-testid="confirm-button">
              {busy ? "Confirming…" : "Yes, I've read it"}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
